module.exports = __webpack_public_path__ + "media/images/bg01-abf479e4dc51cdcf408a8036b56c04a5.jpg";